import React from "react";
import LocationItemLink from "../../../landing/recentlyBooked/LocationItemLink";
import PropTypes from 'prop-types';
import {generateLocationProfileLink} from "../../../../util/LinkUtils";
import {styled} from "@mui/material/styles";

const LocationItemLinkRoot = styled(LocationItemLink)(({theme}) => ({
    maxWidth: '75%',
    [theme.breakpoints.up('md')]: {
        maxWidth: '25%',
    }
}));

const LocationProfileCard = (props) => {
    const { listingImageFileName, pricePerDay, pricePerMonth, instantApproval, locationName, cityName, distanceTo, id } = props;

    return (
        <LocationItemLinkRoot
            listingImageFileName={listingImageFileName}
            pricePerDay={pricePerDay}
            pricePerMonth={pricePerMonth}
            instantApproval={instantApproval}
            locationName={locationName}
            cityName={cityName}
            distanceTo={distanceTo}
            href={generateLocationProfileLink(id)}
            target="_blank"
        />
    )
};


LocationProfileCard.propTypes = {
    listingImageFileName: PropTypes.string,
    pricePerDay: PropTypes.number,
    instantApproval: PropTypes.bool,
    locationName: PropTypes.string,
    cityName: PropTypes.string,
    id: PropTypes.string,
};

export default LocationProfileCard;
